__turbopack_context__.v({
  "control": "AttachmentControl-module__3rrGxq__control",
  "file": "AttachmentControl-module__3rrGxq__file",
  "neutral": "AttachmentControl-module__3rrGxq__neutral",
  "remove": "AttachmentControl-module__3rrGxq__remove",
  "selected": "AttachmentControl-module__3rrGxq__selected",
});
